import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useToastContext } from "../contexts/ToastContext/ToastContext";
import GetUserInfoService from "../service/GetUserInfoService";

function formatDateYYYYMMDD(date) {
  return date.getUTCFullYear() + "-" + (date.getUTCMonth() + 1) + "-" + date.getUTCDate();
}

/**
 * @param {Object} [options]
 * @param {string} [options.statementType] - Override for route-based type: 'walletStatement' | 'extracoinStatement' | 'bonusStatement' | 'extrabonusStatement'
 */
const useTransactions = (options = {}) => {
  const { pathname } = useLocation();
  const derivedRouteName = pathname.split("-")[1];
  const routeName = options.statementType || derivedRouteName;
  const loadAll = options.loadAll === true || routeName === "extracoinStatement";
  const { showErrorToast } = useToastContext();

  const getUserInfoService = new GetUserInfoService();

  const [statementData, setStatementData] = useState([]);
  const [dateBegin, setDateBegin] = useState(null);
  const [dateEnd, setDateEnd] = useState(null);
  const [loading, setLoading] = useState(false);

  async function getTransactionTable(dateBegin, dateEnd, skipDateValidation = false) {
    if (!skipDateValidation && !dateBegin && !dateEnd) {
      showErrorToast({ detail: "emptyDates" });
      return false;
    }

    const dBegin = dateBegin || new Date("2000-01-01");
    const dEnd = dateEnd || new Date();
    const formattedDateBegin = formatDateYYYYMMDD(dBegin);
    const formattedDateEnd = formatDateYYYYMMDD(dEnd);
    setLoading(true);

    if (routeName === "extracoinStatement") {
      try {
        const res = await getUserInfoService.getExtracoinTransactions(
          localStorage.getItem("__extraconomy_token"),
          localStorage.getItem("__extraconomy_username"),
          formattedDateBegin,
          formattedDateEnd
        );

        setStatementData(res.result);
        setLoading(false);
      } catch (e) {
        setLoading(false);
        console.log(e);
      }
    } else if (routeName === "bonusStatement") {
      try {
        const res = await getUserInfoService.getBonusTransactions(
          localStorage.getItem("__extraconomy_token"),
          localStorage.getItem("__extraconomy_username"),
          formattedDateBegin,
          formattedDateEnd
        );

        setStatementData(res.result);
        setLoading(false);
      } catch (e) {
        setLoading(false);
        console.log(e);
      }
    } else if (routeName === "extrabonusStatement") {
      try {
        const res = await getUserInfoService.getExtrabonusTransactions(
          localStorage.getItem("__extraconomy_token"),
          localStorage.getItem("__extraconomy_username"),
          formattedDateBegin,
          formattedDateEnd
        );

        setStatementData(res.result);
        setLoading(false);
      } catch (e) {
        setLoading(false);
        console.log(e);
      }
    } else {
      try {
        const res = await getUserInfoService.getWalletTransactions(
          localStorage.getItem("__extraconomy_token"),
          localStorage.getItem("__extraconomy_username"),
          formattedDateBegin,
          formattedDateEnd
        );

        setStatementData(res.result);
        setLoading(false);
      } catch (e) {
        setLoading(false);
        console.log(e);
      }
    }
  }

  useEffect(() => {
    if (loadAll && routeName === "extracoinStatement") {
      getTransactionTable(new Date("2000-01-01"), new Date(), true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadAll, routeName]);

  return {
    statementData,
    setStatementData,
    dateBegin,
    setDateBegin,
    dateEnd,
    setDateEnd,
    loading,
    setLoading,
    getTransactionTable,
    routeName,
  };
};

export default useTransactions;
